<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
    :size="clientWidth > 1366 ? '1300_auto' : '1200_auto'"
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    :closeOnClickModal="false"
    :contentStyle="{'height': '100%'}"
    no-padding
  >
    <template #header>
      <div v-if="isMeaningful(mailData)" class="flex align-center justify-start">
        <span class="color333 weight600 gj-mr4">{{mailData.emailName}}</span>
        <span class="color333 weight400 gj-mr8">&lt;{{mailData.emailAddress||'无邮箱'}}&gt;</span>
        <img v-if="!mailData.isStar" src="../../../../../assets/images/crm/collection.png" @click.stop="setStarMark(mailData)" class="gj-pointer gj-mr12">
        <img v-else src="../../../../../assets/images/crm/collection2.png" @click.stop="setStarMark(mailData)" class="gj-pointer gj-mr12">
        <template v-for="item in mailData.ticketMarks">
          <gj-tag :key="item" type="dark" class="gj-mr12" :color="setTagColor(item)">{{item === 'NR' ? (item + '-' + mailData.matchTypeDesc) : item}}</gj-tag>
        </template>
      </div>
      <span v-else>邮件详情</span>
    </template>
    <template #content>
      <div style="padding: 0 12px 12px;height: 100%;box-sizing: border-box;">
        <app-mail-reply-buyer-content
            :item="emailItem"
            :marketOptions="marketOptions"
            :mail-type="mailType"
            :feedbackItem="feedbackItem"
            :type="source"
            @load="mailContentLoad"
        ></app-mail-reply-buyer-content>
      </div>

    </template>
  </gj-modal>
</template>

<script>
import AppMailReplyBuyerContent from "@/views/modules/crm/mail-reply/modal/mail-reply-buyer-content";
import {modalMixIn, isMeaningfulMixin} from "@/minxins";
import {setTicketCollection} from "../../../../../api/crm";
import {tagColors} from "@/components/tag/tag-colors";
export default {
  name: "mail-modal",
  components:{ //解决vue中组件的循环引用
    AppMailReplyBuyerContent: () => import("@/views/modules/crm/mail-reply/modal/mail-reply-buyer-content")
  },
  mixins:[
    modalMixIn, isMeaningfulMixin
  ],
  props: {
    emailItem: null,
    marketOptions:null,
    feedbackItem: null,
    mailType: {
      type: String,
      default: 'NR'
    },
    source: {
      type: String,
      default: 'review'
    }
  },
  data(){
    return {
      emailItemType: 'NR',
      confirmLoading: false,
      mailData: null
    }
  },
  methods: {
    mailContentLoad(data) {
      this.mailData = this._.cloneDeep(data)
    },
    setTagColor(type) {
      let color = tagColors.blueDark
      switch(type) {
        case 'Message':
          color = tagColors.blueDark
          break;
        case '联系买家':
          color = tagColors.orangeDark
          break;
        case 'NR':
          color = tagColors.violetDark
          break;
        case 'NF':
          color = tagColors.yellowDark
          break;
        case '关怀邮件':
          color = tagColors.moreVioletDark
          break;
      }
      return color
    },
    // 设置为重要图标
    setStarMark() {
      let params = {
        ticketIds: [this.mailData.id],
        type: !this.mailData.isStar ? 1 : 0
      }
      setTicketCollection(params).then(res => {
        this.$gjMessage.success(res.data);
        this.mailData.isStar = !this.mailData.isStar;
      })
    },
  }
}
</script>

<style scoped>

</style>